var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4019",
    "data-name": "Group 4019",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.007,
    height: 293.688,
    viewBox: "0 0 162.007 293.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3913",
    "data-name": "Group 3913",
    transform: "translate(94.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3756",
    "data-name": "Group 3756",
    transform: "translate(34.349 2.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6594",
    "data-name": "Path 6594",
    d: "M228.57,190.321a6.606,6.606,0,0,0-2.816-12.291,7.258,7.258,0,0,0-5.488-12.408,6.4,6.4,0,0,0,1.383-6.9,9.718,9.718,0,0,0-5.18-5.128,13.658,13.658,0,0,0-17.3,6.3l3.239,56.8a9.764,9.764,0,0,0,15.978-4.123,19.323,19.323,0,0,0,5.922-1.378,6.531,6.531,0,0,0,3.824-4.466c.361-2-.9-4.319-2.913-4.648,2.19-1.393,4.494-2.912,5.576-5.272S231.066,191.034,228.57,190.321Z",
    transform: "translate(-199.167 -152.529)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3912",
    "data-name": "Group 3912",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3911",
    "data-name": "Group 3911",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3761",
    "data-name": "Group 3761",
    transform: "translate(37.056 2.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3760",
    "data-name": "Group 3760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3759",
    "data-name": "Group 3759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3758",
    "data-name": "Group 3758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3757",
    "data-name": "Group 3757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6595",
    "data-name": "Path 6595",
    d: "M213.763,161.414c-.675-2.915-2.865-5.253-5.272-7.03a7.659,7.659,0,0,0-3.357-1.613,3.214,3.214,0,0,0-3.26,1.377l.2,2.089c-.214,3.328,2.394,6.085,3.663,9.169.552,1.341,1.009,2.955,2.349,3.51a3.118,3.118,0,0,0,2.229-.054C213.129,167.841,214.438,164.329,213.763,161.414Z",
    transform: "translate(-201.874 -152.734)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3766",
    "data-name": "Group 3766",
    transform: "translate(0 0.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3765",
    "data-name": "Group 3765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3764",
    "data-name": "Group 3764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3763",
    "data-name": "Group 3763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3762",
    "data-name": "Group 3762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6596",
    "data-name": "Path 6596",
    d: "M214.294,176.78a6.689,6.689,0,0,0-.848-8.534c1.176-1.571.667-3.926-.62-5.408a13.091,13.091,0,0,0-4.963-3.069,9,9,0,0,0-10.684-6.26c-2.43-3.352-7.4-3.742-11.344-2.465a10.646,10.646,0,0,1-2.932.732,17.4,17.4,0,0,1-2.21-.24c-4.058-.423-7.986,2.542-9.45,6.351a7.432,7.432,0,0,1-.807,1.776,10.1,10.1,0,0,1-1.949,1.655,6.46,6.46,0,0,0-2.331,4.847c-.02,1.572.53,3.223-.089,4.668-.31.725-.892,1.32-1.128,2.071-.683,2.179,1.773,4.313,1.4,6.565-.077.46-.27.891-.383,1.343a3.983,3.983,0,0,0,.325,2.777,5.734,5.734,0,0,1,.937,1.976,6.45,6.45,0,0,1-.279,1.643c-.233,1.345,2.8,6.414,3.981,7.106l34.524-.718a6.451,6.451,0,0,0,4.825-5.7,2.363,2.363,0,0,1,.284-1.279,2.777,2.777,0,0,1,.924-.64c2.187-1.259,2.364-4.318,2.056-6.823a3.036,3.036,0,0,1-.012-1.054A3.855,3.855,0,0,1,214.294,176.78Z",
    transform: "translate(-164.818 -150.37)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3865",
    "data-name": "Group 3865",
    transform: "translate(3.496 9.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_28",
    "data-name": "Union 28",
    d: "M8.139,5.772l-.7,24.59c-1.228-.3-7.762-.668-7.427,6.467.271,5.753,4.361,5.77,6.611,5.325a1.045,1.045,0,0,0,.487-.285l-.232,8.2A18.5,18.5,0,0,0,17.156,65.891a22.831,22.831,0,0,0,8.884,1.867,13.979,13.979,0,0,0,8.088-1.949c1.891-.5,8.672-7.095,8.828-14.032.173-7.706.078-17.122-1.064-22.822-2.3-11.46-11.2-12.57-11.2-12.57l.035-9.154L31.477,0Z",
    transform: "translate(43.023 67.802) rotate(180)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3779",
    "data-name": "Group 3779",
    transform: "translate(4.274 24.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3778",
    "data-name": "Group 3778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3777",
    "data-name": "Group 3777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3776",
    "data-name": "Group 3776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3775",
    "data-name": "Group 3775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3774",
    "data-name": "Group 3774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3773",
    "data-name": "Group 3773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3772",
    "data-name": "Group 3772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3771",
    "data-name": "Group 3771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6598",
    "data-name": "Path 6598",
    d: "M172.588,185.391a1.481,1.481,0,0,0,1.487,1.435,1.415,1.415,0,0,0,1.471-1.4,1.482,1.482,0,0,0-1.485-1.436A1.417,1.417,0,0,0,172.588,185.391Z",
    transform: "translate(-172.588 -183.995)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3789",
    "data-name": "Group 3789",
    transform: "translate(2.818 18.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3788",
    "data-name": "Group 3788",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3787",
    "data-name": "Group 3787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3786",
    "data-name": "Group 3786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3785",
    "data-name": "Group 3785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3784",
    "data-name": "Group 3784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3783",
    "data-name": "Group 3783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3782",
    "data-name": "Group 3782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3781",
    "data-name": "Group 3781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3780",
    "data-name": "Group 3780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6599",
    "data-name": "Path 6599",
    d: "M171.159,179.735c.191.185,1.278-.689,2.87-.75,1.589-.083,2.791.689,2.956.487.081-.09-.12-.43-.643-.78a4.071,4.071,0,0,0-2.376-.629,3.9,3.9,0,0,0-2.275.838C171.217,179.3,171.065,179.652,171.159,179.735Z",
    transform: "translate(-171.133 -178.059)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3798",
    "data-name": "Group 3798",
    transform: "translate(8.564 19.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3797",
    "data-name": "Group 3797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3796",
    "data-name": "Group 3796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3795",
    "data-name": "Group 3795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3794",
    "data-name": "Group 3794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3793",
    "data-name": "Group 3793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3792",
    "data-name": "Group 3792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3791",
    "data-name": "Group 3791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6600",
    "data-name": "Path 6600",
    d: "M180.981,191.928a10.509,10.509,0,0,0-2.6-.362c-.408-.026-.8-.091-.876-.366a2.071,2.071,0,0,1,.222-1.215q.514-1.5,1.077-3.144c1.491-4.474,2.553-8.147,2.372-8.205s-1.536,3.521-3.027,8c-.357,1.1-.7,2.154-1.025,3.16a2.357,2.357,0,0,0-.146,1.6,1.023,1.023,0,0,0,.692.567,2.767,2.767,0,0,0,.695.068A10.39,10.39,0,0,0,180.981,191.928Z",
    transform: "translate(-176.878 -178.635)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3806",
    "data-name": "Group 3806",
    transform: "translate(12.277 46.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3805",
    "data-name": "Group 3805",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3804",
    "data-name": "Group 3804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3803",
    "data-name": "Group 3803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3802",
    "data-name": "Group 3802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3801",
    "data-name": "Group 3801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3800",
    "data-name": "Group 3800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3799",
    "data-name": "Group 3799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6601",
    "data-name": "Path 6601",
    d: "M180.644,210.808a29.36,29.36,0,0,0,15.28-4.745s-3.745,8.451-15.333,7.839Z",
    transform: "translate(-180.591 -206.063)",
    opacity: 0.19
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3817",
    "data-name": "Group 3817",
    transform: "translate(3.21 12.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3816",
    "data-name": "Group 3816",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3815",
    "data-name": "Group 3815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3814",
    "data-name": "Group 3814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3813",
    "data-name": "Group 3813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3812",
    "data-name": "Group 3812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3811",
    "data-name": "Group 3811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3810",
    "data-name": "Group 3810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3809",
    "data-name": "Group 3809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3808",
    "data-name": "Group 3808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3807",
    "data-name": "Group 3807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6602",
    "data-name": "Path 6602",
    d: "M171.561,173.744c.283.378,1.492.069,2.921.13,1.43.014,2.623.387,2.922.025.133-.177-.038-.549-.547-.92a4.529,4.529,0,0,0-4.709-.125C171.623,173.2,171.437,173.56,171.561,173.744Z",
    transform: "translate(-171.524 -172.254)",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3826",
    "data-name": "Group 3826",
    transform: "translate(17.663 24.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3825",
    "data-name": "Group 3825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3824",
    "data-name": "Group 3824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3823",
    "data-name": "Group 3823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3821",
    "data-name": "Group 3821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3820",
    "data-name": "Group 3820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3819",
    "data-name": "Group 3819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3818",
    "data-name": "Group 3818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6603",
    "data-name": "Path 6603",
    d: "M188.931,185.327a1.48,1.48,0,0,1-1.423,1.5,1.416,1.416,0,0,1-1.53-1.33A1.481,1.481,0,0,1,187.4,184,1.417,1.417,0,0,1,188.931,185.327Z",
    transform: "translate(-185.977 -183.993)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3836",
    "data-name": "Group 3836",
    transform: "translate(18.797 18.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3835",
    "data-name": "Group 3835",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3834",
    "data-name": "Group 3834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3833",
    "data-name": "Group 3833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3832",
    "data-name": "Group 3832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3831",
    "data-name": "Group 3831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3830",
    "data-name": "Group 3830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3829",
    "data-name": "Group 3829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3828",
    "data-name": "Group 3828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3827",
    "data-name": "Group 3827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6604",
    "data-name": "Path 6604",
    d: "M192.963,179.478c-.183.194-1.307-.633-2.9-.624-1.592-.014-2.759.81-2.932.615-.085-.086.1-.435.609-.808a4.069,4.069,0,0,1,2.346-.731,3.909,3.909,0,0,1,2.309.738C192.886,179.043,193.053,179.391,192.963,179.478Z",
    transform: "translate(-187.111 -177.93)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847",
    transform: "translate(18.808 13.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3846",
    "data-name": "Group 3846",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3845",
    "data-name": "Group 3845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3844",
    "data-name": "Group 3844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    "data-name": "Group 3843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    "data-name": "Group 3842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    "data-name": "Group 3840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    "data-name": "Group 3839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3838",
    "data-name": "Group 3838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6605",
    "data-name": "Path 6605",
    d: "M193.2,174.123c-.313.363-1.543-.009-3.021-.022-1.477-.059-2.729.251-3.018-.126-.127-.184.069-.547.615-.891a4.815,4.815,0,0,1,4.866.12C193.163,173.574,193.336,173.946,193.2,174.123Z",
    transform: "translate(-187.122 -172.482)",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3864",
    "data-name": "Group 3864",
    transform: "translate(37.414 28.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3863",
    "data-name": "Group 3863",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3862",
    "data-name": "Group 3862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3861",
    "data-name": "Group 3861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3860",
    "data-name": "Group 3860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3859",
    "data-name": "Group 3859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3858",
    "data-name": "Group 3858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3857",
    "data-name": "Group 3857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3856",
    "data-name": "Group 3856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6607",
    "data-name": "Path 6607",
    d: "M205.735,193.775c.033-.027.141.089.378.184a1.368,1.368,0,0,0,1.025-.027c.816-.344,1.453-1.7,1.424-3.114a4.517,4.517,0,0,0-.475-1.943,1.584,1.584,0,0,0-1.08-1,.7.7,0,0,0-.79.413c-.1.225-.038.38-.079.395-.021.021-.175-.123-.127-.451a.868.868,0,0,1,.286-.507,1.036,1.036,0,0,1,.748-.236,1.926,1.926,0,0,1,1.488,1.152,4.652,4.652,0,0,1,.578,2.169c.025,1.586-.717,3.107-1.838,3.489a1.47,1.47,0,0,1-1.262-.149C205.758,193.964,205.708,193.79,205.735,193.775Z",
    transform: "translate(-205.728 -187.484)",
    fill: "#ff9a6c"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3872",
    "data-name": "Group 3872",
    transform: "translate(1.773 5.258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3871",
    "data-name": "Group 3871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3870",
    "data-name": "Group 3870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3869",
    "data-name": "Group 3869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3868",
    "data-name": "Group 3868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3867",
    "data-name": "Group 3867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3866",
    "data-name": "Group 3866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6608",
    "data-name": "Path 6608",
    d: "M166.591,175.594a4.574,4.574,0,0,0,2.336-4.315c1.066.272,2.082-1.127,2.66-2.063s1.313-1.426,1.222-2.523a1.238,1.238,0,0,1,.054-.641c.147-.308.517-.422.839-.536a5.271,5.271,0,0,0,3.323-3.8,11.154,11.154,0,0,0,5.425.675,4.263,4.263,0,0,0,7.2-.6,3.815,3.815,0,0,0,2.63,1.782,11.289,11.289,0,0,0,3.269.048,4.515,4.515,0,0,0,3.172,4.99c.283.075.61.147.749.4a1.137,1.137,0,0,1-.086.881,3.553,3.553,0,0,0,2.557,4.426,2.649,2.649,0,0,0,.4,4.138c.293.161.675.354.644.687a.748.748,0,0,1-.16.342,5.153,5.153,0,0,0-1.136,2.648,1.9,1.9,0,0,0,1.641,2.042,2.523,2.523,0,0,0-.931,1.762c.016.684.735,1.353,1.363,1.081.267-.116,4.152-1.041,4.315-1.282,2.105-3.109-.826-6.336-1.195-10.072a24.414,24.414,0,0,0-3.822-10.488,17.84,17.84,0,0,0-2.944-3.679,23.726,23.726,0,0,0-4.45-3.012,21.711,21.711,0,0,0-6.429-2.757c-4.283-.832-8.631.885-12.517,2.871a18.476,18.476,0,0,0-4.171,2.689,16.74,16.74,0,0,0-3.413,4.843,20.866,20.866,0,0,0-2.526,8.164",
    transform: "translate(-166.591 -155.517)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3880",
    "data-name": "Group 3880",
    transform: "translate(0.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3879",
    "data-name": "Group 3879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3878",
    "data-name": "Group 3878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3877",
    "data-name": "Group 3877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3876",
    "data-name": "Group 3876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3875",
    "data-name": "Group 3875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3874",
    "data-name": "Group 3874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3873",
    "data-name": "Group 3873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6609",
    "data-name": "Path 6609",
    d: "M164.939,172.9a3.009,3.009,0,0,1,.392-.86c.156-.268.38-.582.587-.981a3.665,3.665,0,0,0,.384-1.486,11.419,11.419,0,0,0-.11-1.944,8.674,8.674,0,0,1-.028-2.337,6.556,6.556,0,0,1,.938-2.518,6.474,6.474,0,0,1,.924-1.15,9.687,9.687,0,0,1,1.207-.973,4.841,4.841,0,0,0,1.155-1.077,6.362,6.362,0,0,0,.689-1.509,10.552,10.552,0,0,1,4.75-5.576,9.338,9.338,0,0,1,1.865-.784,8.451,8.451,0,0,1,2.058-.314,9.721,9.721,0,0,1,1.063.044c.354.041.7.1,1.054.15a5.069,5.069,0,0,0,2.1-.078c.7-.166,1.38-.447,2.1-.655a13.8,13.8,0,0,1,4.518-.59,11.989,11.989,0,0,1,2.323.337,7.759,7.759,0,0,1,4.059,2.461l.307.376-.128-.045a9.132,9.132,0,0,1,10.825,6.347l-.065-.077a24.951,24.951,0,0,1,2.813,1.35,8.294,8.294,0,0,1,2.327,1.927,5.382,5.382,0,0,1,1.127,2.676,3.718,3.718,0,0,1-.649,2.687l-.012-.131a6.524,6.524,0,0,1,1.965,3.968,6.685,6.685,0,0,1-.669,3.94,6.466,6.466,0,0,1-.493.8,8.49,8.49,0,0,0-.515.723,1.691,1.691,0,0,0-.25.782,4.833,4.833,0,0,0,.053.815,12.9,12.9,0,0,1,.03,2.989,6.254,6.254,0,0,1-.687,2.3,3.86,3.86,0,0,1-1.175,1.323c-.4.283-.75.4-.944.554a1.887,1.887,0,0,0-.278.248.914.914,0,0,1,.26-.272c.192-.164.547-.293.928-.579a3.833,3.833,0,0,0,1.132-1.316,6.214,6.214,0,0,0,.652-2.272,12.954,12.954,0,0,0-.054-2.959,4.774,4.774,0,0,1-.06-.84,1.84,1.84,0,0,1,.264-.849,8.615,8.615,0,0,1,.52-.739,6.3,6.3,0,0,0,.475-.781,6.515,6.515,0,0,0,.632-3.842,6.333,6.333,0,0,0-1.92-3.847l-.066-.061.054-.071a3.518,3.518,0,0,0,.6-2.545,5.189,5.189,0,0,0-1.09-2.567,8.092,8.092,0,0,0-2.272-1.87,24.823,24.823,0,0,0-2.79-1.332l-.051-.022-.014-.055a8.908,8.908,0,0,0-10.543-6.172l-.074.02-.053-.065-.3-.363a7.532,7.532,0,0,0-3.937-2.385,11.749,11.749,0,0,0-2.274-.33,13.643,13.643,0,0,0-2.264.1,13.85,13.85,0,0,0-2.178.469c-.707.2-1.393.486-2.113.656a5.4,5.4,0,0,1-1.1.156,6.534,6.534,0,0,1-1.089-.077c-.355-.05-.7-.111-1.049-.152a9.4,9.4,0,0,0-1.032-.044,8.276,8.276,0,0,0-2,.3,9.213,9.213,0,0,0-1.824.762,10.391,10.391,0,0,0-4.679,5.457,6.5,6.5,0,0,1-.716,1.547,5.05,5.05,0,0,1-1.2,1.111,9.47,9.47,0,0,0-1.194.95,6.316,6.316,0,0,0-.909,1.118,6.43,6.43,0,0,0-.934,2.457,8.565,8.565,0,0,0,.01,2.305,11.425,11.425,0,0,1,.089,1.962,3.7,3.7,0,0,1-.414,1.513c-.217.4-.447.71-.609.973a4.561,4.561,0,0,0-.337.615C164.969,172.828,164.945,172.906,164.939,172.9Z",
    transform: "translate(-164.939 -150.259)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3888",
    "data-name": "Group 3888",
    transform: "translate(16.991 0.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3887",
    "data-name": "Group 3887",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3886",
    "data-name": "Group 3886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3885",
    "data-name": "Group 3885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3884",
    "data-name": "Group 3884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3883",
    "data-name": "Group 3883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3882",
    "data-name": "Group 3882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3881",
    "data-name": "Group 3881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6610",
    "data-name": "Path 6610",
    d: "M193.421,151.921c-.011.018-.212-.111-.6-.284a5.276,5.276,0,0,0-1.734-.436,4.975,4.975,0,0,0-2.571.474,5.134,5.134,0,0,0-2.272,2.22,4.323,4.323,0,0,0-.357.9.983.983,0,0,0,.088.827l.2.26-.321-.078a3.263,3.263,0,0,0-2.421.381,3.157,3.157,0,0,0-1.279,1.506A3.437,3.437,0,0,0,181.9,159c0,.316.033.488.015.491s-.021-.04-.041-.122a2.166,2.166,0,0,1-.054-.366,3.291,3.291,0,0,1,1.512-2.986,3.428,3.428,0,0,1,2.581-.435l-.119.182a1.2,1.2,0,0,1-.134-1.021,4.47,4.47,0,0,1,.376-.96,5.273,5.273,0,0,1,2.388-2.307,5.025,5.025,0,0,1,2.681-.444,4.922,4.922,0,0,1,1.758.519,3.476,3.476,0,0,1,.427.257C193.38,151.876,193.426,151.914,193.421,151.921Z",
    transform: "translate(-181.809 -151.004)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3896",
    "data-name": "Group 3896",
    transform: "translate(31.292 10.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3895",
    "data-name": "Group 3895",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3894",
    "data-name": "Group 3894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3893",
    "data-name": "Group 3893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3892",
    "data-name": "Group 3892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3891",
    "data-name": "Group 3891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3890",
    "data-name": "Group 3890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3889",
    "data-name": "Group 3889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6611",
    "data-name": "Path 6611",
    d: "M206.523,160.469a1.226,1.226,0,0,1-.265.292,5.053,5.053,0,0,1-.866.651,3.76,3.76,0,0,1-1.551.53,2.809,2.809,0,0,1-1.975-.517l.173-.033-.219.332c-.08.108-.17.212-.256.319a4.766,4.766,0,0,1-1.919,1.3,4.892,4.892,0,0,1-1.866.306,4.33,4.33,0,0,1-1.249-.236,1.544,1.544,0,0,1-.419-.2,6.772,6.772,0,0,0,1.671.272,5,5,0,0,0,1.785-.342,4.715,4.715,0,0,0,1.819-1.249c.081-.1.167-.2.243-.3s.14-.21.207-.312l.074-.11.1.077a2.645,2.645,0,0,0,1.813.495,3.786,3.786,0,0,0,1.492-.458C206.1,160.84,206.5,160.436,206.523,160.469Z",
    transform: "translate(-196.111 -160.467)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    "data-name": "Group 3904",
    transform: "translate(33.979 16.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3903",
    "data-name": "Group 3903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3902",
    "data-name": "Group 3902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3901",
    "data-name": "Group 3901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3899",
    "data-name": "Group 3899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3898",
    "data-name": "Group 3898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3897",
    "data-name": "Group 3897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6612",
    "data-name": "Path 6612",
    d: "M210.954,167.607c.008,0,0,.051-.014.145a1.343,1.343,0,0,1-.161.387,2.093,2.093,0,0,1-1.235.89,4.01,4.01,0,0,1-2.256-.159,12.731,12.731,0,0,1-1.26-.443,2.146,2.146,0,0,1-1.123-.949l-.054-.124.187.049a9.015,9.015,0,0,1-2.28,1.489,4.052,4.052,0,0,1-2.2.311,2.915,2.915,0,0,1-1.384-.568,1.779,1.779,0,0,1-.295-.28c-.06-.072-.087-.112-.081-.117s.145.131.43.323a3.027,3.027,0,0,0,1.352.477,4,4,0,0,0,2.093-.346,9.254,9.254,0,0,0,2.213-1.47l.121-.1.066.152.045.1a1.947,1.947,0,0,0,1.005.84c.408.18.834.315,1.229.446a3.963,3.963,0,0,0,2.148.207,2.092,2.092,0,0,0,1.2-.779A3.639,3.639,0,0,0,210.954,167.607Z",
    transform: "translate(-198.797 -167.119)",
    fill: "#455a64"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3910",
    "data-name": "Group 3910",
    transform: "translate(16.428 43.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3906",
    "data-name": "Group 3906",
    transform: "translate(0 0.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    "data-name": "Group 3905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6613",
    "data-name": "Path 6613",
    d: "M186.318,195.486a3.155,3.155,0,0,0-.387-.985,1.064,1.064,0,0,0-.885-.5,1.569,1.569,0,0,0-.71.284q-1.424.86-2.845,1.721l-.245.7a7.8,7.8,0,0,0,2.2,2.231,1.612,1.612,0,0,0,.873.34,1.807,1.807,0,0,0,1.066-.524,2.443,2.443,0,0,0,.934-3.262Z",
    transform: "translate(-181.246 -193.996)",
    opacity: 0.19
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3909",
    "data-name": "Group 3909",
    transform: "translate(0.202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3908",
    "data-name": "Group 3908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3907",
    "data-name": "Group 3907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6614",
    "data-name": "Path 6614",
    d: "M184.2,199.488a5.5,5.5,0,0,0,1.384-.932,3.088,3.088,0,0,0,.815-1.541,3.15,3.15,0,0,0-.325-2.08,2.892,2.892,0,0,0-.312-.466,1.367,1.367,0,0,0-.37-.343.417.417,0,0,0-.378-.036,2.691,2.691,0,0,0-.435.242c-.6.369-1.141.7-1.6.966a7.3,7.3,0,0,1-1.528.8,7.2,7.2,0,0,1,1.373-1.047c.439-.3.965-.654,1.552-1.04a2.81,2.81,0,0,1,.5-.29.817.817,0,0,1,.706.051,1.743,1.743,0,0,1,.49.435,3.076,3.076,0,0,1,.357.53,3.4,3.4,0,0,1,.334,2.351,3.218,3.218,0,0,1-.981,1.671,3.044,3.044,0,0,1-1.116.657C184.373,199.509,184.2,199.511,184.2,199.488Z",
    transform: "translate(-181.448 -193.668)",
    fill: "#263238"
  }))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4018",
    "data-name": "Group 4018",
    transform: "translate(0 65.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3927",
    "data-name": "Group 3927",
    transform: "translate(0 42.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3922",
    "data-name": "Group 3922",
    transform: "translate(40.352 26.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3914",
    "data-name": "Group 3914",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6615",
    "data-name": "Path 6615",
    d: "M111.031,296.117l3.926-5.936,6.3-3.161.236-.172a8.454,8.454,0,0,1,7.149-1.329c2.566.682,5.991,1.533,8.962,2.04l6.783-1.855v13.238l-34.213-2.161Z",
    transform: "translate(-110.177 -285.234)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3921",
    "data-name": "Group 3921",
    transform: "translate(1.089 4.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3917",
    "data-name": "Group 3917",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3916",
    "data-name": "Group 3916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6616",
    "data-name": "Path 6616",
    d: "M111.268,295.757a9.043,9.043,0,0,1,1.445-1.321c.926-.773,2.224-1.818,3.673-2.952l1.357-1.053.04-.031.047-.009c1.4-.263,2.622-.475,3.492-.61a5.563,5.563,0,0,1,1.4-.143,5.46,5.46,0,0,1-1.352.4c-.856.205-2.065.47-3.462.757l.086-.039-1.348,1.064c-1.449,1.134-2.776,2.141-3.75,2.854A8.829,8.829,0,0,1,111.268,295.757Z",
    transform: "translate(-111.266 -289.621)",
    fill: "#ff9a6c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3920",
    "data-name": "Group 3920",
    transform: "translate(2.668 3.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3919",
    "data-name": "Group 3919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3918",
    "data-name": "Group 3918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6617",
    "data-name": "Path 6617",
    d: "M113.935,296.913a38.917,38.917,0,0,1,4.921-2.97l1.2-.658.042-.023.045,0a26.713,26.713,0,0,1,4.38-.074,26.561,26.561,0,0,1-4.353.486l.086-.025-1.194.669A39.112,39.112,0,0,1,113.935,296.913Z",
    transform: "translate(-113.934 -293.128)",
    fill: "#ff9a6c"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3926",
    "data-name": "Group 3926",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3923",
    "data-name": "Group 3923",
    transform: "translate(0.052 0.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6618",
    "data-name": "Path 6618",
    d: "M71.207,258.666a2.605,2.605,0,0,1,3.373.724l27.555,37.32,43.6.591c1.742.1,3.854,3.623,2.293,5.327l-49.237-.673-28.425-39.5A2.606,2.606,0,0,1,71.207,258.666Z",
    transform: "translate(-69.877 -258.332)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3925",
    "data-name": "Group 3925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3924",
    "data-name": "Group 3924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6619",
    "data-name": "Path 6619",
    d: "M71.207,258.666a1.349,1.349,0,0,0-.218.119,2.439,2.439,0,0,0-.55.489,2.64,2.64,0,0,0-.4,2.73,15.4,15.4,0,0,0,1.163,1.745l1.453,2.043,3.6,5.055,22.371,31.227.06.083h.1l48.344.689.891.012h.1l.071-.076a2.443,2.443,0,0,0,.6-1.758,4.28,4.28,0,0,0-.463-1.744,5.1,5.1,0,0,0-1.057-1.44,2.507,2.507,0,0,0-1.652-.774l-6.735-.089-13.015-.17-23.741-.3.158.081-21.671-29.21-6.1-8.16a2.63,2.63,0,0,0-2.455-.886,1.988,1.988,0,0,0-.86.331,3.459,3.459,0,0,1,.87-.269,2.574,2.574,0,0,1,2.351.9l6.01,8.219,21.537,29.309.058.08h.1l23.734.345,13.012.183,6.733.093a2.044,2.044,0,0,1,1.354.649,4.652,4.652,0,0,1,.957,1.307,2.705,2.705,0,0,1-.064,2.985l.174-.075-.892-.012L98.8,301.752l.162.085L76.452,270.708,72.8,265.684l-1.476-2.026a15.92,15.92,0,0,1-1.175-1.7,2.575,2.575,0,0,1,.338-2.638A3.315,3.315,0,0,1,71.207,258.666Z",
    transform: "translate(-69.825 -258.294)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3936",
    "data-name": "Group 3936",
    transform: "translate(70.318 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_27",
    "data-name": "Union 27",
    d: "M24.358.668,2.317.5S-1.726,3.275.868,8.687c1.446,3.02,2.479,7.656,1.85,10.774S.822,41.33.822,46.32.088,68.087,1.006,72.6a18.449,18.449,0,0,0,5.126,9.483,31.93,31.93,0,0,0,5.43,3.653,38.873,38.873,0,0,0,8-.8c2.438-.415,4.454-.829,4.585-.837,1.434-.475,10.971-3.58,10.971-3.58,7.68-11.162,15.821-21.3,18.953-28.957,5.47-13.38-1.207-21.68-1.207-21.68a26.276,26.276,0,0,1-.029-7.478l24.889-5.2L76.67.968S46.143.676,32.292.039C31.717.013,31.157,0,30.61,0A27.484,27.484,0,0,0,24.358.668ZM24.15,84.1c-.225.074-.25.084-.007.007.015,0,.018-.007.011-.007Z",
    transform: "translate(77.963 85.774) rotate(180)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3931",
    "data-name": "Group 3931",
    transform: "translate(45.852 59.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3930",
    "data-name": "Group 3930",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6622",
    "data-name": "Path 6622",
    d: "M186,274.779c-.108.086.988,1.516,1.91,3.511s1.328,3.747,1.464,3.719a11.583,11.583,0,0,0-3.374-7.23Z",
    transform: "translate(-185.995 -274.775)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3933",
    "data-name": "Group 3933",
    transform: "translate(35.162 17.638)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3932",
    "data-name": "Group 3932",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6623",
    "data-name": "Path 6623",
    d: "M187.586,233.244c-4.565,14.029-3.574,35.659-12.281,43.633l10.788-2.252A54.746,54.746,0,0,1,186,267c.875-11.091.981-22.37,1.584-33.76",
    transform: "translate(-175.305 -233.244)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3935",
    "data-name": "Group 3935",
    transform: "translate(0 12.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3934",
    "data-name": "Group 3934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6624",
    "data-name": "Path 6624",
    d: "M188.6,228.239a25.252,25.252,0,0,0-.8,3.184,38.414,38.414,0,0,0-.557,3.927c-.149,1.561-.172,3.364-.248,5.383-.26,8.1-.632,19.72-1.087,33.886l.148-.176-45.719,9.5-.193.041.013.2c.336,5.2.689,10.669,1.05,16.245l.013.213.215,0,5.558.063c7.944.1,15.7.219,23.189.381q5.617.12,11.022.295c3.586.092,7.146.431,10.593-.111a23.066,23.066,0,0,0,4.97-1.279,21.2,21.2,0,0,0,4.387-2.4,29.825,29.825,0,0,0,6.6-6.85q1.335-1.878,2.525-3.752l.592-.931c.186-.318.35-.65.525-.971l.513-.967c.132-.336.263-.672.393-1.005a38.445,38.445,0,0,0,2.042-7.932,124.3,124.3,0,0,0,1.338-14c.206-4.133.3-7.694.4-10.6s.2-5.167.275-6.7c.047-.754.083-1.332.108-1.74.022-.392.021-.594.021-.594s-.03.2-.068.59c-.036.407-.087.985-.154,1.738-.109,1.529-.242,3.787-.362,6.7s-.248,6.469-.478,10.6a126.029,126.029,0,0,1-1.4,13.955,38.307,38.307,0,0,1-2.051,7.854q-.195.492-.39.989c-.168.312-.336.627-.5.942s-.332.636-.515.949l-.594.927q-1.189,1.866-2.524,3.726a29.475,29.475,0,0,1-6.52,6.745,20.791,20.791,0,0,1-4.3,2.34,22.632,22.632,0,0,1-4.881,1.247c-3.382.527-6.909.188-10.514.09q-5.4-.185-11.028-.306c-7.491-.168-15.248-.292-23.193-.391l-5.56-.062.229.216c-.363-5.575-.72-11.046-1.058-16.245l-.18.237,45.7-9.584.143-.03,0-.146c.387-14.168.705-25.792.926-33.891.061-2.021.067-3.822.2-5.375s.313-2.867.5-3.921.374-1.854.5-2.39c.063-.258.112-.458.148-.607A1.082,1.082,0,0,0,188.6,228.239Z",
    transform: "translate(-140.143 -228.239)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4017",
    "data-name": "Group 4017",
    transform: "translate(5.707 84.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3937",
    "data-name": "Group 3937",
    transform: "translate(13.324 71.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6625",
    "data-name": "Path 6625",
    d: "M111.63,372.1l6.55,50-17.134,2.911-12.19-44.365Z",
    transform: "translate(-88.856 -372.103)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    "data-name": "Group 3938",
    transform: "translate(2.957 1.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6626",
    "data-name": "Path 6626",
    d: "M165.8,304.744s-62.63-4.269-75.631-2.121c-7.859,1.3-14.632,14.023-10.349,21.669,2.027,3.619,5.218,14.89,5.218,14.89l33.662-7.953Z",
    transform: "translate(-78.49 -302.019)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3939",
    "data-name": "Group 3939",
    transform: "translate(23.456 38.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6627",
    "data-name": "Path 6627",
    d: "M118.7,339.182l13.561,21.439L116.3,371.334,98.988,343.84Z",
    transform: "translate(-98.988 -339.182)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3940",
    "data-name": "Group 3940",
    transform: "translate(0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6628",
    "data-name": "Path 6628",
    d: "M209.657,300.819s6.321,29.942-4.064,42.106-25.737,12.164-41.54,9.825-53.321-3.153-53.321-3.153,1.674,10.629,2.9,22.727c1.227,12.129,1.477,19.744,1.477,19.744L91.622,394.1s-13.086-41.269-15.1-49.441-1.332-19.151,5.628-23.224c5.9-3.452,52.417-16.817,74.687-18.8l2.419-2.153Z",
    transform: "translate(-75.535 -300.475)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3942",
    "data-name": "Group 3942",
    transform: "translate(23.711 39.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3941",
    "data-name": "Group 3941",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6629",
    "data-name": "Path 6629",
    d: "M99.243,339.66c-.013.084.91.217,2.3.735a14.62,14.62,0,0,1,2.348,1.13,16.519,16.519,0,0,1,2.561,1.926,16.928,16.928,0,0,1,2.113,2.441,15.53,15.53,0,0,1,1.326,2.3c.641,1.383.863,2.319.943,2.3a1.98,1.98,0,0,0-.1-.672,10.135,10.135,0,0,0-.559-1.76,13.673,13.673,0,0,0-1.278-2.416,15.564,15.564,0,0,0-2.15-2.539,15.151,15.151,0,0,0-2.658-1.954,12.829,12.829,0,0,0-2.45-1.069,9.343,9.343,0,0,0-1.747-.4A1.79,1.79,0,0,0,99.243,339.66Z",
    transform: "translate(-99.243 -339.642)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3944",
    "data-name": "Group 3944",
    transform: "translate(23.447 9.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3943",
    "data-name": "Group 3943",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6630",
    "data-name": "Path 6630",
    d: "M102.034,314.739a7.022,7.022,0,0,0-1.237-2.519,6.812,6.812,0,0,0-1.809-2.116,37.628,37.628,0,0,0,3.046,4.635Z",
    transform: "translate(-98.979 -310.099)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3946",
    "data-name": "Group 3946",
    transform: "translate(0 2.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3945",
    "data-name": "Group 3945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6631",
    "data-name": "Path 6631",
    d: "M75.535,333.169a.97.97,0,0,0,.069-.233l.159-.692c.14-.608.357-1.5.707-2.63a20.318,20.318,0,0,1,1.669-3.933,9.658,9.658,0,0,1,3.788-3.95,101.517,101.517,0,0,1,13.536-4.985c5.194-1.61,10.922-3.315,16.968-4.972,12.1-3.328,23.2-5.71,31.284-7.1,4.042-.708,7.327-1.192,9.6-1.519l2.616-.369.679-.107a.915.915,0,0,0,.23-.052.893.893,0,0,0-.235.005l-.684.062-2.628.282c-2.279.272-5.574.707-9.627,1.375a307.4,307.4,0,0,0-31.346,6.975c-6.054,1.658-11.783,3.378-16.974,5.011a98.071,98.071,0,0,0-13.559,5.1,9.878,9.878,0,0,0-3.862,4.113A19.87,19.87,0,0,0,76.3,329.56c-.327,1.143-.517,2.048-.629,2.664-.047.287-.085.518-.116.7A.979.979,0,0,0,75.535,333.169Z",
    transform: "translate(-75.532 -302.623)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3981",
    "data-name": "Group 3981",
    transform: "translate(9.388 112.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3976",
    "data-name": "Group 3976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3949",
    "data-name": "Group 3949",
    transform: "translate(0.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3948",
    "data-name": "Group 3948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3947",
    "data-name": "Group 3947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6632",
    "data-name": "Path 6632",
    d: "M99.715,423.717l-.571-2.168a32.035,32.035,0,0,0,18.91-8.445l5.806,13L85.143,443.946C83.681,440.11,99.715,423.717,99.715,423.717Z",
    transform: "translate(-85.049 -413.104)",
    fill: "#7b6bd9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3958",
    "data-name": "Group 3958",
    transform: "translate(0 9.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3957",
    "data-name": "Group 3957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3956",
    "data-name": "Group 3956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3955",
    "data-name": "Group 3955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3954",
    "data-name": "Group 3954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3953",
    "data-name": "Group 3953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3952",
    "data-name": "Group 3952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3951",
    "data-name": "Group 3951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3950",
    "data-name": "Group 3950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6633",
    "data-name": "Path 6633",
    d: "M123.86,426.108l-1.418-3.176L85.775,441.259s-1.381,1.551-.632,2.687Z",
    transform: "translate(-84.92 -422.932)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3968",
    "data-name": "Group 3968",
    transform: "translate(15.301 9.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3967",
    "data-name": "Group 3967",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3966",
    "data-name": "Group 3966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3965",
    "data-name": "Group 3965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3964",
    "data-name": "Group 3964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3963",
    "data-name": "Group 3963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3962",
    "data-name": "Group 3962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3961",
    "data-name": "Group 3961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3960",
    "data-name": "Group 3960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3959",
    "data-name": "Group 3959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6634",
    "data-name": "Path 6634",
    d: "M100.231,423.465c.093.188,1.078-.161,2.285.024,1.213.153,2.066.758,2.206.6.158-.117-.641-1.128-2.107-1.325S100.111,423.309,100.231,423.465Z",
    transform: "translate(-100.222 -422.729)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3971",
    "data-name": "Group 3971",
    transform: "translate(30.268 7.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3970",
    "data-name": "Group 3970",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3969",
    "data-name": "Group 3969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6635",
    "data-name": "Path 6635",
    d: "M115.3,422.072a1.114,1.114,0,0,0,1.49.531,1.133,1.133,0,0,0,.526-1.5,1.113,1.113,0,0,0-1.49-.53A1.131,1.131,0,0,0,115.3,422.072Z",
    transform: "translate(-115.188 -420.458)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3975",
    "data-name": "Group 3975",
    transform: "translate(10.132 6.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3974",
    "data-name": "Group 3974",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3973",
    "data-name": "Group 3973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3972",
    "data-name": "Group 3972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    "data-name": "Path 6636",
    d: "M100.464,423.2a2.45,2.45,0,0,0,.878-.166,4.661,4.661,0,0,0,2.173-1.2,3.4,3.4,0,0,0,.507-.692,2.168,2.168,0,0,0,.325-.923.991.991,0,0,0-.607-.99,1.428,1.428,0,0,0-1.174.054,4.494,4.494,0,0,0-2.394,3.915l.571-.085a4.877,4.877,0,0,0-.382-.9,4.733,4.733,0,0,0-4.2-2.459,1.415,1.415,0,0,0-.651.132.856.856,0,0,0-.439.594,1.589,1.589,0,0,0,.279,1.158,3.5,3.5,0,0,0,1.483,1.234,5.8,5.8,0,0,0,2.658.411,3.326,3.326,0,0,0,.97-.083,2.97,2.97,0,0,0-.963-.147,6.328,6.328,0,0,1-2.484-.557,3.142,3.142,0,0,1-1.253-1.121,1.106,1.106,0,0,1-.187-.782c.048-.224.232-.3.589-.294a4.241,4.241,0,0,1,3.683,2.2,4.38,4.38,0,0,1,.336.788.292.292,0,0,0,.571-.085,4.018,4.018,0,0,1,2.03-3.437c.524-.29,1.137-.04,1.09.432a2.711,2.711,0,0,1-.657,1.365,4.958,4.958,0,0,1-1.949,1.263A3.117,3.117,0,0,0,100.464,423.2Z",
    transform: "translate(-95.052 -419.124)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3978",
    "data-name": "Group 3978",
    transform: "translate(12.337 12.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3977",
    "data-name": "Group 3977",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    "data-name": "Path 6637",
    d: "M97.26,426.249a13.639,13.639,0,0,1,2.562.186,13.916,13.916,0,0,1,2.346,1.078,3.28,3.28,0,0,0-2.239-1.527A3.179,3.179,0,0,0,97.26,426.249Z",
    transform: "translate(-97.258 -425.844)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3980",
    "data-name": "Group 3980",
    transform: "translate(10.18 15.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3979",
    "data-name": "Group 3979",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6638",
    "data-name": "Path 6638",
    d: "M95.1,428.8c.011.136,1.06.1,2.268.483,1.214.363,2.076.983,2.157.875a3.389,3.389,0,0,0-2.03-1.319A3.275,3.275,0,0,0,95.1,428.8Z",
    transform: "translate(-95.101 -428.611)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4016",
    "data-name": "Group 4016",
    transform: "translate(26.288 54.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4011",
    "data-name": "Group 4011",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3984",
    "data-name": "Group 3984",
    transform: "translate(0.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3983",
    "data-name": "Group 3983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3982",
    "data-name": "Group 3982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6639",
    "data-name": "Path 6639",
    d: "M113.264,368.919l-.916-2.037a32.512,32.512,0,0,0,17.269-11.624l7.836,11.806L102.186,391.4C100.122,387.875,113.264,368.919,113.264,368.919Z",
    transform: "translate(-101.966 -355.258)",
    fill: "#7b6bd9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3993",
    "data-name": "Group 3993",
    transform: "translate(0 8.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3992",
    "data-name": "Group 3992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3991",
    "data-name": "Group 3991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3990",
    "data-name": "Group 3990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3989",
    "data-name": "Group 3989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3988",
    "data-name": "Group 3988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3987",
    "data-name": "Group 3987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3986",
    "data-name": "Group 3986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3985",
    "data-name": "Group 3985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6640",
    "data-name": "Path 6640",
    d: "M137.453,367.064l-1.914-2.884-33.166,24.463s-1.109,1.77-.187,2.758Z",
    transform: "translate(-101.82 -364.18)",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4003",
    "data-name": "Group 4003",
    transform: "translate(11.897 12.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4002",
    "data-name": "Group 4002",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4001",
    "data-name": "Group 4001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4000",
    "data-name": "Group 4000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3999",
    "data-name": "Group 3999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3998",
    "data-name": "Group 3998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3997",
    "data-name": "Group 3997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3996",
    "data-name": "Group 3996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3995",
    "data-name": "Group 3995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3994",
    "data-name": "Group 3994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6641",
    "data-name": "Path 6641",
    d: "M113.732,368.581c.122.169,1.035-.347,2.256-.376,1.22-.06,2.16.387,2.272.21.136-.144-.814-1-2.292-.94S113.588,368.448,113.732,368.581Z",
    transform: "translate(-113.717 -367.472)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4006",
    "data-name": "Group 4006",
    transform: "translate(26.335 7.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4005",
    "data-name": "Group 4005",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4004",
    "data-name": "Group 4004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6642",
    "data-name": "Path 6642",
    d: "M128.357,364.579a1.105,1.105,0,0,0,1.555.263,1.139,1.139,0,0,0,.274-1.573,1.106,1.106,0,0,0-1.555-.264A1.14,1.14,0,0,0,128.357,364.579Z",
    transform: "translate(-128.155 -362.796)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4010",
    "data-name": "Group 4010",
    transform: "translate(6.343 8.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4009",
    "data-name": "Group 4009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4008",
    "data-name": "Group 4008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4007",
    "data-name": "Group 4007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6643",
    "data-name": "Path 6643",
    d: "M113.918,368.277a2.477,2.477,0,0,0,.838-.317A4.745,4.745,0,0,0,116.7,366.4a3.45,3.45,0,0,0,.388-.77,2.19,2.19,0,0,0,.17-.967.978.978,0,0,0-.759-.871,1.434,1.434,0,0,0-1.148.259,4.552,4.552,0,0,0-1.724,4.276l.549-.183a4.862,4.862,0,0,0-.523-.821,4.676,4.676,0,0,0-4.537-1.691,1.442,1.442,0,0,0-.62.243.87.87,0,0,0-.336.662,1.568,1.568,0,0,0,.463,1.093,3.435,3.435,0,0,0,1.663.958,5.792,5.792,0,0,0,2.686-.058,3.358,3.358,0,0,0,.943-.251,2.914,2.914,0,0,0-.973.023,6.314,6.314,0,0,1-2.539-.116,3.085,3.085,0,0,1-1.418-.886,1.1,1.1,0,0,1-.311-.738c.011-.23.18-.336.533-.394a4.192,4.192,0,0,1,3.988,1.528,4.279,4.279,0,0,1,.459.718.289.289,0,0,0,.392.128.3.3,0,0,0,.158-.311,4.07,4.07,0,0,1,1.442-3.742c.469-.378,1.114-.238,1.145.235a2.764,2.764,0,0,1-.427,1.461,5.034,5.034,0,0,1-1.715,1.584C114.17,368.071,113.9,368.24,113.918,368.277Z",
    transform: "translate(-108.163 -363.755)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4013",
    "data-name": "Group 4013",
    transform: "translate(9.432 15.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4012",
    "data-name": "Group 4012",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6644",
    "data-name": "Path 6644",
    d: "M111.256,371.843a13.693,13.693,0,0,1,2.554-.263,13.821,13.821,0,0,1,2.49.653,3.237,3.237,0,0,0-2.456-1.114A3.2,3.2,0,0,0,111.256,371.843Z",
    transform: "translate(-111.252 -371.104)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4015",
    "data-name": "Group 4015",
    transform: "translate(7.72 19.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4014",
    "data-name": "Group 4014",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    "data-name": "Path 6645",
    d: "M109.541,374.73c.033.132,1.062-.084,2.314.08,1.255.146,2.206.607,2.268.486a3.332,3.332,0,0,0-2.215-.946A3.279,3.279,0,0,0,109.541,374.73Z",
    transform: "translate(-109.54 -374.31)",
    fill: "#263238"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar);
export default __webpack_public_path__ + "static/media/char.0d7c5f8ddc7e185b417f71995cc79d4d.svg";
export { ForwardRef as ReactComponent };